export const IS_PROD = process.env.NODE_ENV === 'production';
export const IS_BETA = process.env.APP_ENV === 'beta';

export const BASE_URL = IS_PROD ? 'https://www.aced.io' : 'http://localhost:3000';
export const TWITTER_HANDLE = '@aced_io';

export const LOGROCKET_KEY = 'ozkys8/exponent';

export const MIXPANEL_TOKEN = IS_PROD && !IS_BETA
  ? '0cf3766ea20bf45e90eb54006c31dcd9'
  : '48ca900564bf11c104d701f7c3b76b3b';

export const CUSTOMERIO_BROWSER_KEY = '17137f350335b3bbc805';

export const STRIPE_PUBLIC_KEY = IS_PROD
  ? 'pk_live_avIqegTkj7HdBjlWl1X8GR4Y'
  : 'pk_test_GpA7lrfWsEl3Y2J5YhWn0QaR';

export const SPLIT_KEY = IS_PROD
  ? 'bn7ve84g9mvf1g6r92nb18l20ktlgsv2t9v3'
  : 'imo2omvajc6l4lu38n4k7ts36dq47d3gi6pb';

export const GOOGLE_WEB_CLIENT_ID = '934940858286-m70el7hic17143vaturv3m06b4ai824n.apps.googleusercontent.com';

export const SENTRY_DSN = 'https://fa0f026b85654b05a9b2d89f4899f92e@sentry.io/1245747';
